import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React, { useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { UncontrolledTooltip } from "reactstrap";
import {
  getUseUrlShortener,
  setUseUrlShortener,
} from "../../../../cores/socialPost/helpers/urlShortenerPreference";
import "./UrlShortenerOptions.scss";

export const UrlShortenerOptions = () => {
  const intl = useIntl();
  const [enabled, setEnabled] = useState(() => getUseUrlShortener());
  const tipId = useMemo(
    () => `url-shortener-help-${Math.random().toString(36).slice(2, 8)}`,
    []
  );

  const toggle = () => {
    const next = !enabled;
    setEnabled(next);
    setUseUrlShortener(next);
  };

  return (
    <div className="url-shortener-options">
      <button
        type="button"
        id={tipId}
        className={cn("url-shortener-btn", {
          "url-shortener-btn--on": enabled,
        })}
        onClick={toggle}
        aria-pressed={enabled}
      >
        <FontAwesomeIcon icon={["fas", "link"]} />
        <span>
          {intl.formatMessage({
            id: enabled
              ? "app.socialPost.urlShortener.buttonOn"
              : "app.socialPost.urlShortener.buttonOff",
          })}
        </span>
      </button>
      <UncontrolledTooltip target={tipId} placement="top">
        {intl.formatMessage({
          id: "app.socialPost.urlShortener.tooltipBody",
        })}
      </UncontrolledTooltip>
    </div>
  );
};
